import React, { FC } from 'react';
import { Typography } from 'design_system/src';
import { ReactComponent as Close } from 'design_system/src/static/icons/close-circle.svg';
import { ReactComponent as CircleAdd } from 'design_system/src/static/icons/add-circle.svg';
import './loadRecoveryEvidence.scss';

interface DocumentsProps {
	image: File | undefined;
	setImage: React.Dispatch<React.SetStateAction<File | undefined>>;
	placeholder?: string;
	className?: string;
}

const LoadRecoveryEvidence: FC<DocumentsProps> = ({
	image,
	setImage,
	placeholder,
	className,
}) => {
	return image ? (
		<div className={`recovery_image_card dso_card ${className}`}>
			<div className="dim_100_per overflow_hidden br_md">
				<img
					src={URL.createObjectURL(image)}
					alt=""
					className="img_cover dim_100_per"
				/>
			</div>
			<Close
				className="dim_xl delete_recovery_image text_red_300"
				onClick={() => {
					setImage(undefined);
				}}
			/>
		</div>
	) : (
		<div
			className={`dso_card border_primary_200 border_dashed p_sm flex_center_col cursor_pointer flex_gap_md recovery_image_card ${className}`}
		>
			<CircleAdd className="dim_xl text_primary_300" />

			<Typography
				scale="small"
				weight="600"
				className="text_center"
				textColor="primary_300"
			>
				{placeholder || 'Añadir imagen'}
			</Typography>
			<input
				type="file"
				accept="image/*"
				onChange={(e: any) => setImage(e.target.files[0])}
				capture="environment"
				className="input-file"
			/>
		</div>
	);
};

export default LoadRecoveryEvidence;
